import React from 'react';
import { Facebook, GitHub, Twitter, Instagram, LinkedIn } from "@material-ui/icons";
import pb from "../assets/images/PB.jpg";
import bg from "../assets/images/BG.jpg";
import bb from "../assets/images/BB.jpg";
import { NavLink } from 'react-router-dom';

const Team = () => {
    return (
        <section id="team" className="team-clean">
            <div className="container">
                <div className="row">
                    <div className="col col-md-12 text-center">
                        <h2 className="text-dark">Our Core Team</h2>
                        <hr className="my-4 mx-auto" />
                    </div>
                </div>
                <div className="row people">
                    <div className="col-md-6 col-lg-4 item">
                        <img className="rounded-circle" data-aos="zoom-in" data-aos-duration="250" src={pb} alt="Parthava" />
                        <h3 className="name">Parthava Borah<br /></h3>
                        <p className="title">Co-founder<br /></p>
                        <p className="description">I'm one of the co-founders of onedotall and also I work as a Backend developer for our team. Click below to know more about me.<br /></p>
                        <div className="social">
                            <NavLink to="/p404"><Facebook /></NavLink>
                            <NavLink to="/p404"><GitHub /></NavLink>
                            <NavLink to="/p404"><Twitter /></NavLink>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 item">
                        <img className="rounded-circle" data-aos="zoom-in" data-aos-duration="250" data-aos-delay="250" src={bg} alt="Bimal" />
                        <h3 className="name">Bimal Goswami<br /></h3>
                        <p className="title">Founder<br /></p>
                        <p className="description">I laid the concept of having fun together and here we are. I assemble things together and with my two amazing partners, doing great!<br /></p>
                        <div className="social">
                            <NavLink to="/p404"><Instagram /></NavLink>
                            <NavLink to="/p404"><LinkedIn /></NavLink>
                            <NavLink to="/p404"><Twitter /></NavLink>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 item">
                        <img className="rounded-circle" data-aos="zoom-in" data-aos-duration="250" data-aos-delay="500" src={bb} alt="Bishal" />
                        <h3 className="name">Bishaljyoti Bora<br /></h3>
                        <p className="title">Co-founder<br /></p>
                        <p className="description">I'm one of the co-founders of Onedotall and also I work as a frontend developer for our team. Click below if you want to follow me.<br /></p>
                        <div className="social">
                            <NavLink to="/p404"><Facebook /></NavLink>
                            <NavLink to="/p404"><GitHub /></NavLink>
                            <NavLink to="/p404"><Instagram /></NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Team
